import { Component } from 'react';
import PropTypes from 'prop-types';
import SnackbarSystem from '@ui/systems/SnackbarSystem';
import { handleAsyncActionResult } from '../lib/reduxUtils';

export default class Container extends Component {
	// eslint-disable-next-line react/no-unused-class-component-methods
	handleAsyncActionResult(
		asyncActionResult,
		successTexts,
		errorTexts,
		resetAction,
		onSuccess,
		onError
	) {
		const { snackbarSystem } = this.props;

		return handleAsyncActionResult(
			asyncActionResult,
			successTexts,
			errorTexts,
			resetAction,
			snackbarSystem.showSuccessMessage,
			snackbarSystem.showErrorMessage,
			onSuccess,
			onError
		);
	}

	// eslint-disable-next-line react/no-unused-class-component-methods
	showAsyncActionConfirmation(
		text,
		acceptText,
		cancelText,
		asyncAction,
		description = null,
		acceptButtonColor = 'blue'
	) {
		const { showDefaultConfirmationDialog, hideConfirmationDialog } = this.props;

		showDefaultConfirmationDialog( text, description, acceptText, cancelText, 'left', acceptButtonColor )
			.then( ( wasConfirmed ) => {
				if ( !wasConfirmed ) { return; }

				asyncAction()
					.then( () => hideConfirmationDialog() );
			} );
	}
}

Container.propTypes = {
	snackbarSystem: PropTypes.instanceOf( SnackbarSystem ),
	showDefaultConfirmationDialog: PropTypes.func,
	hideConfirmationDialog: PropTypes.func
};

Container.defaultProps = {
	showDefaultConfirmationDialog: () => {},
	hideConfirmationDialog: () => {}
};
